export interface CountryCode {
  isoCode: string;
  numberPrefix: string;
}

export const SUPPORTED_PREFIX: CountryCode[] = [
  {
    isoCode: "CZ",
    numberPrefix: "+420",
  },
  {
    isoCode: "SK",
    numberPrefix: "+421",
  },
  {
    isoCode: "AT",
    numberPrefix: "+43",
  },
  {
    isoCode: "BE",
    numberPrefix: "+32",
  },
  {
    isoCode: "BG",
    numberPrefix: "+359",
  },
  {
    isoCode: "HR",
    numberPrefix: "+385",
  },
  {
    isoCode: "CY",
    numberPrefix: "+357",
  },
  {
    isoCode: "DK",
    numberPrefix: "+45",
  },
  {
    isoCode: "EE",
    numberPrefix: "+372",
  },
  {
    isoCode: "FI",
    numberPrefix: "+358",
  },
  {
    isoCode: "FR",
    numberPrefix: "+33",
  },
  {
    isoCode: "DE",
    numberPrefix: "+49",
  },
  {
    isoCode: "GR",
    numberPrefix: "+30",
  },
  {
    isoCode: "HU",
    numberPrefix: "+36",
  },
  {
    isoCode: "IS",
    numberPrefix: "+354",
  },
  {
    isoCode: "IE",
    numberPrefix: "+353",
  },
  {
    isoCode: "IT",
    numberPrefix: "+39",
  },
  {
    isoCode: "LV",
    numberPrefix: "+371",
  },
  {
    isoCode: "LI",
    numberPrefix: "+423",
  },
  {
    isoCode: "LT",
    numberPrefix: "+370",
  },
  {
    isoCode: "LU",
    numberPrefix: "+352",
  },
  {
    isoCode: "MT",
    numberPrefix: "+356",
  },
  {
    isoCode: "NL",
    numberPrefix: "+31",
  },
  {
    isoCode: "NO",
    numberPrefix: "+47",
  },
  {
    isoCode: "PL",
    numberPrefix: "+48",
  },
  {
    isoCode: "PT",
    numberPrefix: "+351",
  },
  {
    isoCode: "RO",
    numberPrefix: "+40",
  },
  {
    isoCode: "SI",
    numberPrefix: "+386",
  },
  {
    isoCode: "ES",
    numberPrefix: "+34",
  },
  {
    isoCode: "CH",
    numberPrefix: "+41",
  },
  {
    isoCode: "GB",
    numberPrefix: "+44",
  },
  {
    isoCode: "SE",
    numberPrefix: "+46",
  },
];
